import * as types from '../../../constants/actionTypes';
import api from '../../../../shared/api.json';
import uriTemplate from 'uri-template';

export function upload(profileId, file) {
    const url = uriTemplate
        .parse(api.profiles.images.post)
        .expand({ profileId });

    return {
        types: [
            types.UPLOAD_IMAGE,
            types.UPLOAD_IMAGE_SUCCESS,
            types.UPLOAD_IMAGE_FAIL,
        ],
        promise: (client) =>
            client.post(url, { fileUpload: { file, name: file.name } }),
    };
}

export function update(profileId, file) {
    const imageId = file.id;
    const url = uriTemplate
        .parse(api.profiles.images.put)
        .expand({ profileId, imageId });

    return {
        types: [
            types.UPDATE_IMAGE,
            types.UPDATE_IMAGE_SUCCESS,
            types.UPDATE_IMAGE_FAIL,
        ],
        promise: (client) => client.put(url, { data: file }),
        imageId,
    };
}

export function remove(profileId, imageId) {
    const url = uriTemplate
        .parse(api.profiles.images.put)
        .expand({ profileId, imageId });

    return {
        types: [
            types.REMOVE_IMAGE,
            types.REMOVE_IMAGE_SUCCESS,
            types.REMOVE_IMAGE_FAIL,
        ],
        promise: (client) => client.del(url),
        imageId,
    };
}

export function reorder(profileId, reorderList) {
    const url = uriTemplate
        .parse(api.profiles.images.reorder)
        .expand({ profileId });

    return {
        types: [
            types.REORDER_IMAGE,
            types.REORDER_IMAGE_SUCCESS,
            types.REORDER_IMAGE_FAIL,
        ],
        promise: (client) => client.post(url, { data: { reorderList } }),
        reorderList,
    };
}
